export default {
	props: {
		isSkeleton: {
			type: Boolean,
			default: true,
		},
		autoSkeleton: {
			type: Boolean,
			default: true,
		},
		assessment: {
			type: Object,
			required: true,
		},
	},
	computed: {
		highType() {
			return ( this.assessment?.moniker || [ "X", ] )[ 0 ].toUpperCase();
		},
	},
};
